<div class="p-4">
  <div class="columns is-4 is-darkblue is-size-5 p-2">
    <div class="column has-text-weight-bold ">
      <div *ngIf="data.property.name else townAndStreet" class="title is-darkblue" style="margin-bottom: 0;">
        Rechnungsempfänger
      </div>
      <div class="has-text-info">{{ data.property.name }}</div>
      <ng-template #townAndStreet>
        <div class="title is-darkblue" style="margin-bottom: 0;">Rechnungsempfänger</div>
        <div class="has-text-info">{{ data.property.town }}, {{ data.property.street }}</div>
      </ng-template>
      <form id="billingForm" [formGroup]="billingForm">
        <input class="input" placeholder="Vor- und Nachname (optional)" formControlName="name"
               [ngClass]="{'has-error': hasError(billingForm.get('name'))}">
        <small *ngIf="billingForm.get('name').hasError('maxlength') && billingForm.get('name').touched"
               style="color: red; font-size: 10px;">
          Maximale Zeichenanzahl überschritten
        </small>
        <input class="input" placeholder="Firma" formControlName="firma"
               [ngClass]="{'has-error': hasError(billingForm.get('firma'))}">
        <small *ngIf="billingForm.get('firma').hasError('maxlength') && billingForm.get('firma').touched"
               style="color: red; font-size: 10px;">
          Maximale Zeichenanzahl überschritten
        </small>
        <input class="input" placeholder="Straße" formControlName="street"
               [ngClass]="{'has-error': hasError(billingForm.get('street'))}">
        <small *ngIf="billingForm.get('street').hasError('maxlength') && billingForm.get('street').touched"
               style="color: red; font-size: 10px;">
          Maximale Zeichenanzahl überschritten
        </small>
          <div class="columns">
            <div class="column is-4">
              <input class="input" placeholder="PLZ" formControlName="plz"
                     [ngClass]="{'has-error': hasError(billingForm.get('plz'))}">
            </div>
            <div class="column">
              <input class="input" placeholder="Stadt" formControlName="town"
                     [ngClass]="{'has-error': hasError(billingForm.get('town'))}">
              <small *ngIf="billingForm.get('town').hasError('maxlength') && billingForm.get('town').touched"
                     style="color: red; font-size: 10px;">
                Maximale Zeichenanzahl überschritten
              </small>
            </div>
          </div>
          <div class="select is-fullwidth" [ngClass]="{'has-error': hasError(billingForm.get('country'))}">
            <select formControlName="country"
                    [ngClass]="{'has-error': hasError(billingForm.get('country'))}">
              <option value="" disabled>Land</option>
              <option *ngFor="let country of countries" [value]="country.name">{{ country.name }}</option>
            </select>
          </div>
      </form>
    </div>
  </div>
  <div class="title is-darkblue" style="margin-bottom: 0;">Leistungsempfänger</div>
  <div>
    <label class="is-darkblue">
      <input type="checkbox" (change)="updateDialog()" [checked]="!showBeneficiary"/>
      Leistungsempfänger entspricht dem Rechnungsempfänger
    </label>
  </div>
  <div *ngIf="showBeneficiary">
    <form id="beneficiaryForm" [formGroup]="beneficiaryForm">
      <input class="input" placeholder="Vor- und Nachname (optional)" formControlName="name"
             [ngClass]="{'has-error': hasError(beneficiaryForm.get('name'))}">
      <small *ngIf="beneficiaryForm.get('name').hasError('maxlength') && beneficiaryForm.get('name').touched"
             style="color: red; font-size: 10px;">
        Maximale Zeichenanzahl überschritten
      </small>
      <input class="input" placeholder="Firma" formControlName="firma"
             [ngClass]="{'has-error': hasError(beneficiaryForm.get('firma'))}">
      <small *ngIf="beneficiaryForm.get('firma').hasError('maxlength') && beneficiaryForm.get('firma').touched"
             style="color: red; font-size: 10px;">
        Maximale Zeichenanzahl überschritten
      </small>
      <input class="input" placeholder="Straße" formControlName="street"
             [ngClass]="{'has-error': hasError(beneficiaryForm.get('street'))}">
      <small *ngIf="beneficiaryForm.get('street').hasError('maxlength') && beneficiaryForm.get('street').touched"
             style="color: red; font-size: 10px;">
        Maximale Zeichenanzahl überschritten
      </small>
      <div class="columns">
        <div class="column is-4">
          <input class="input" placeholder="PLZ" formControlName="plz"
                 [ngClass]="{'has-error': hasError(beneficiaryForm.get('plz'))}">
        </div>
        <div class="column">
          <input class="input" placeholder="Stadt" formControlName="town"
                 [ngClass]="{'has-error': hasError(beneficiaryForm.get('town'))}">
          <small *ngIf="beneficiaryForm.get('town').hasError('maxlength') && beneficiaryForm.get('town').touched"
                 style="color: red; font-size: 10px;">
            Maximale Zeichenanzahl überschritten
          </small>
        </div>
      </div>
      <div class="select is-fullwidth" [ngClass]="{'has-error': hasError(beneficiaryForm.get('country'))}">
        <select formControlName="country">
          <option value="" disabled>Land</option>
          <option *ngFor="let country of countries" [value]="country.name">{{ country.name }}</option>
        </select>
      </div>
    </form>
  </div>
  <br>
  <div class="columns">
    <div class="column is-one-third">
      <app-button content="Zurück" cancel="true" (click)="closeBillingForm()"></app-button>
    </div>
    <div class="column is-one-third">
    </div>
    <div class="column is-one-third">
      <button class="button is-blue" type="submit" form="billingForm" (click)="hiddenButton.click()">Weiter</button>
      <button #hiddenButton type="submit" form="beneficiaryForm" (click)="submitBillingForm()"
              style="display: none"></button>
    </div>
  </div>
</div>
